import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import Login from "./components/login.component";
import SignUp from "./components/signup.component";
import PersonalInfo from "./components/Personalinfo";
import TestFormat from "./components/TestPurpose";
import TestpurposeNw from "./components/TestpurposeNw";
import ForgotPassword from "./components/ForgotPassword";

function App() {
  return (
    <Router>
      <div className="App">
        <nav className="navbar navbar-expand-lg navbar-light fixed-top">
          <div className="container">
            <div className="collapse navbar-collapse" id="navbarTogglerDemo02">
              <ul className="navbar-nav ml-auto">
                <li className="nav-item">
                  <Link className="nav-link" to={"/sign-in"}>
                    Login
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={"/sign-up"}>
                    Sign up
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={"/personalinfo"}>
                    Personal info
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to={"/test"}>
                    Test
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to={"/test2"}>
                    Test 2
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className="auth-wrapper">
          <div className="auth-inner">
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route path="/sign-in" element={<Login />} />
              <Route path="/sign-up" element={<SignUp />} />
              <Route path="/personalinfo" element={<PersonalInfo />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/test2" element={<TestpurposeNw />} />

              <Route path="/test" element={<TestFormat />} />
            </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}

export default App;
